import { render, staticRenderFns } from "./roletable.vue?vue&type=template&id=1b3b2f52&scoped=true&"
import script from "./roletable.vue?vue&type=script&lang=js&"
export * from "./roletable.vue?vue&type=script&lang=js&"
import style0 from "./roletable.vue?vue&type=style&index=0&id=1b3b2f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b2f52",
  null
  
)

export default component.exports